var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5 24.25V6.75C5 4.67875 6.67875 3 8.75 3H16.6788C18.005 3 19.2762 3.52625 20.2137 4.465L23.535 7.78625C24.4737 8.72375 25 9.995 25 11.3212V24.25C25 26.3212 23.3212 28 21.25 28H8.75C6.67875 28 5 26.3212 5 24.25Z",
    fill: "#101AA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.25H12.5C11.1187 24.25 10 23.1313 10 21.75V18C10 16.6188 11.1187 15.5 12.5 15.5H17.5C18.8812 15.5 20 16.6188 20 18V21.75C20 23.1313 18.8812 24.25 17.5 24.25Z",
    fill: "#101AA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimIcon);
export default __webpack_public_path__ + "static/media/SimIcon.1ead052cbcfc55f8b4a6da222a65822f.svg";
export { ForwardRef as ReactComponent };